import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "max-w-2xl lg:max-w-7xl mx-auto space-y-8 sm:space-y-16" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-2xl flex flex-col gap-4 text-center mx-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "grid grid-cols-4 gap-4 lg:grid-cols-8 lg:grid-rows-4 sm:gap-8"
}
const _hoisted_4 = { class: "col-span-4 lg:col-span-7 lg:row-span-4" }
const _hoisted_5 = ["aria-label", "aria-pressed", "onClick"]
const _hoisted_6 = { class: "pointer-events-none w-full h-full" }

import { computed, ref } from "vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { BlockMedia, PageBlock, MediaType } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";

// Import shared components
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Media from "@/views/blocks/shared/section/media/media/Media.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";

import type { WithPanelProps } from "./WithPanelProps";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithPanel',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3ca36174": (styleValues.value.brand)
}))

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const selectedImageIndex = ref(0);

const defaultImage: BlockMedia = {
    mediaType: MediaType.IMAGE,
    src: "",
    alt: "Select an image from the gallery",
    videoSrc: "",
    videoAutoplay: false,
    videoControls: false,
    videoLoop: false,
    iframeSrc: "",
};

const selectedImage = computed(() => {
    return dataValues.value.images.data.items.length > selectedImageIndex.value
        ? dataValues.value.images.data.items[selectedImageIndex.value]
        : defaultImage;
});

const onPanelImageClick = (imageIndex: number) => {
    selectedImageIndex.value = imageIndex;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    "background-color": styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (
                        !dataValues.value.tag.isHidden ||
                        !dataValues.value.title.isHidden ||
                        !dataValues.value.description.isHidden
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (!dataValues.value.tag.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 0,
                        blockId: _ctx.block.id,
                        "field-name": "tag"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Heading, {
                            text: dataValues.value.tag.data.text,
                            tag: dataValues.value.tag.data.tag,
                            "text-color": styleValues.value.brand
                          }, null, 8, ["text", "tag", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.title.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 1,
                        blockId: _ctx.block.id,
                        "field-name": "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Heading, {
                            text: dataValues.value.title.data.text,
                            tag: dataValues.value.title.data.tag,
                            "text-color": styleValues.value.text,
                            class: "text-4xl sm:text-5xl"
                          }, null, 8, ["text", "tag", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.description.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 2,
                        blockId: _ctx.block.id,
                        "field-name": "description"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Paragraph, {
                            text: dataValues.value.description.data.text,
                            "text-color": styleValues.value.text,
                            class: "text-lg opacity-70"
                          }, null, 8, ["text", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (dataValues.value.images.data.items.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_Transition, {
                      name: "image-fade",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("div", {
                          key: selectedImage.value.src,
                          class: "w-full h-full aspect-[16/9] rounded-lg sm:rounded-3xl overflow-hidden"
                        }, [
                          _createVNode(Media, {
                            data: selectedImage.value,
                            "image-width": 1116,
                            "image-height": 628,
                            "video-width": 1116,
                            "video-height": 628
                          }, null, 8, ["data"])
                        ]))
                      ]),
                      _: 1
                    })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.images.data.items, (image, index) => {
                    return (_openBlock(), _createBlock(EditableElement, {
                      key: image.id,
                      blockId: _ctx.block.id,
                      "field-name": `images_${image.id}`,
                      hideable: false,
                      onSelect: () => onPanelImageClick(index)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["aspect-square rounded-lg sm:rounded-3xl cursor-pointer hover:opacity-80 border-2 border-transparent focus:outline-none overflow-hidden panel-button", { 'active-button': index === selectedImageIndex.value }]),
                          "aria-label": `Select media ${index + 1}: ${
                                !image.mediaType || image.mediaType === _unref(MediaType).IMAGE
                                    ? image.alt
                                    : ''
                            }`,
                          "aria-pressed": index === selectedImageIndex.value,
                          onClick: ($event: any) => (onPanelImageClick(index))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(Media, {
                              data: image,
                              "image-width": 128,
                              "image-height": 128,
                              "video-width": 128,
                              "video-height": 128,
                              tabindex: "-1"
                            }, null, 8, ["data"])
                          ])
                        ], 10, _hoisted_5)
                      ]),
                      _: 2
                    }, 1032, ["blockId", "field-name", "onSelect"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "background-color", "scrollAnimationType"]))
}
}

})